import { NgModule } from "@angular/core";
import { APP_BASE_HREF, CommonModule} from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { AppRoutingModule } from './app.routing';
import { AppComponent } from "./app.component";
import { CaseSearchComponent } from "./case-search/casesearch.component";
import { CaseDetailsComponent } from "./case-details/casedetails.component";
import { CSSLoaderComponent } from './loader/loader.component'
import { AppService } from "./app.service";


@NgModule({	
    imports: [BrowserModule, CommonModule, HttpModule, HttpClientModule, ReactiveFormsModule, FormsModule, AppRoutingModule],
    declarations: [AppComponent, CaseSearchComponent, CaseDetailsComponent, CSSLoaderComponent],
	providers: [{ provide: APP_BASE_HREF, useValue: "/" }, AppService],
	bootstrap: [AppComponent]
})

export class AppModule { }


// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/app.module.ts